module.exports = __webpack_public_path__ + "static/media/case_bg.631341d7.png";